import { useStaticQuery, graphql } from 'gatsby'

export function useDataFooterByHy() {
    const data = useStaticQuery(graphql`
        {
            menu: allDatoCmsRenshinMenuFooter(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    id
                    title
                    url
                    parentSection {
                        id
                        title
                    }
                }
            }

            projects: allDatoCmsRenshinProject(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    title
                    urlCode
                    originalId
                }
            }

            copy: datoCmsRenshinPageOther(title: { eq: "License" }, locale: { eq: "hy" }) {
                value
            }

            policy: datoCmsRenshinPageOther(title: { eq: "Privacy Policy" }, locale: { eq: "hy" }) {
                value
            }

            developer: datoCmsRenshinPageOther(title: { eq: "Developer" }, locale: { eq: "hy" }) {
                value
            }

            language: datoCmsRenshinPageOther(title: { eq: "Language" }, locale: { eq: "en" }) {
                value
            }

            fb: datoCmsRenshinSocial(title: { eq: "Facebook" }, locale: { eq: "hy" }) {
                title
                url
            }

            linkedin: datoCmsRenshinSocial(title: { eq: "Linkedin" }, locale: { eq: "hy" }) {
                title
                url
            }

            inst: datoCmsRenshinSocial(title: { eq: "Instagram" }, locale: { eq: "hy" }) {
                title
                url
            }

            YouTube: datoCmsRenshinSocial(title: { eq: "Youtube" }, locale: { eq: "hy" }) {
                title
                url
            }
        }
    `)

    return data
}
